export enum LEADERBOARDS_FILTER {
  REFFERALS = 'referrals',
  JACKPOT = 'jackpot/wins',
  DOUBLE = 'double',
  LUCKY = 'jackpot/lucky',
  LOOTBOX = 'lootbox',
  MINES = 'mines',
}

export type ApiResponseLeaderboards = {
  result: Record<
    Exclude<LEADERBOARDS_FILTER, LEADERBOARDS_FILTER.LUCKY>,
    Array<LeaderboardRecord | DoubleLeaderboardRecord>
  >
  lastUpdate: number
  start: number
  end: number
}

export type ApiResponseLeaderboardsLucky = {
  result: Array<LeaderboardLuckyRecord>
  lastUpdate: number
  start: number
  end: number
}

export type LeaderboardLuckyRecord = {
  gameId: string
  winAmount: string
  bet: string
  chances: string
  Id: string
}

export type LeaderboardRecord = {
  Id: string
  Denom: string
  ReferralTotalRewards: string
  ClaimsCount: string
  Jackpot_WinCount: string
  Jackpot_BetAmount: string
  Jackpot_BetCount: string
  Jackpot_GameCount: string
  Jackpot_WinAmount: string
  Jackpot_TopWinAmount: string
  Lootbox_TotalAmount: string
  Lootbox_BetAmount: string
  Lootbox_BetCount: string
  Lootbox_GameCount: string
  Lootbox_WinAmount: string
  Lootbox_TopWinAmount: string
  Mines_TotalAmount: string
  Mines_BetAmount: string
  Mines_BetCount: string
  Mines_GameCount: string
  Mines_WinAmount: string
  Mines_TopWinAmount: string
  Total_WinCount: string
  Total_BetAmount: string
  Total_BetCount: string
  Total_GameCount: string
  Total_WinAmount: string
  Total_TopWinAmount: string
  ReferralsCount: string
  NewReferralsCount: string
  ActiveReferralsCount: string
}

export type DoubleLeaderboardRecord = {
  Id: string
  double_totalprofit: string
  Double_GameCount: string
  Double_JackpotWins: string
}

export type LootboxCompetitionLeaderboardRecord = {
  player: string
  gameScore: number
  score: number
  referralScore: number
  isNftOwner: boolean
}

export type LootboxLeaderboardRecord = {
  Id: string
  Lootbox_TotalAmount: string
  Lootbox_BetAmount: string
  Lootbox_BetCount: string
  Lootbox_GameCount: string
  Lootbox_WinAmount: string
  Lootbox_TopWinAmount: string
}

export type MinesLeaderboardRecord = {
  Id: string
  Denom: string
  Mines_TotalAmount: string
  Mines_BetAmount: string
  Mines_BetCount: string
  Mines_GameCount: string
  Mines_WinAmount: string
  Mines_TopWinAmount: string
}

export type HTTPErrorResponse = {
  error: unknown
}

export enum Game {
  JACKPOT = 'jackpot',
  DOUBLE = 'double',
  LOOTBOX = 'lootbox',
  MINES = 'mines',
  COINFLIP = 'coinflip',
  RUNES = 'runes',
  PLINKO = 'plinko',
  GAMEZONE = 'gamezone',
}

export enum GameRules {
  JACKPOT = 'jackpot',
  DOUBLE = 'double',
  LOOTBOX = 'lootbox',
  OPENING_COMPETITION = 'opening-competition',
  MINES = 'mines',
  BASKET = 'basket',
  COINFLIP = 'coinflip',
  BONUS_FUNDS = 'bonus-funds',
  RUNES = 'runes',
  RUNES_COMPETITION = 'runes-competition',
  PLINKO = 'plinko',
}
